import { navigate } from "gatsby";
import React, { useContext } from "react";
import TestLogin from "../components/Login/TestLogin";
import { AuthContext } from "../contexts/AuthContext";

const Login = () => {
  const { path, setPath } = useContext(AuthContext);
  const handleClickRememberPass = () => navigate("/recordar");

  const onLogin = (__, loginType) => {
    if (path && path.replaceAll("/", "") === "mis-examenes") {
      setPath("/");
      navigate("/mis-examenes");
    } else navigate(loginType.home);
  };

  return (
    <TestLogin onRecoveryBtn={handleClickRememberPass} onLogin={onLogin} />
  );
};

export default Login;
